import { englishType } from 'types'

export const lesson18: englishType[] = [
  {
    id: 1,
    word: "presentation",
    meaning: ["발표"]
  }, {
    id: 2,
    word: "forward",
    meaning: ["앞으로"]
  }, {
    id: 3,
    word: "highlight",
    meaning: ["눈에 띄게 하다", "강조하다"]
  }, {
    id: 4,
    word: "disappointment",
    meaning: ["실망", "실망감"]
  }, {
    id: 5,
    word: "add",
    meaning: ["추가하다", "합하다", "첨가하다"]
  }, {
    id: 6,
    word: "heritage",
    meaning: ["유산"]
  }, {
    id: 7,
    word: "ritual",
    meaning: ["의식", "의례"]
  }, {
    id: 8,
    word: "used to",
    meaning: ["~하곤 했다", "~이었다"]
  }, {
    id: 9,
    word: "defeat",
    meaning: ["타도", "패배", "타도시키다", "패배시키다"]
  }, {
    id: 10,
    word: "tension",
    meaning: ["긴장감"]
  }, {
    id: 11,
    word: "unforgettable",
    meaning: ["잊지 못할", "잊을 수 없는"]
  }, {
    id: 12,
    word: "intangible",
    meaning: ["무형의", "뭐라 말할 수 없는"]
  }, {
    id: 13,
    word: "under the heading of",
    meaning: ["~라는 제목 아래에", "~라는 제목 하에", "~의 표제로", "~라는 표제로"]
  }, {
    id: 14,
    word: "exactly",
    meaning: ["정확하게", "정확히"]
  }, {
    id: 15,
    word: "historical",
    meaning: ["역사적인"]
  }, {
    id: 16,
    word: "common",
    meaning: ["흔한"]
  }, {
    id: 17,
    word: "cooperate",
    meaning: ["협동하다", "협력하다", "협조하다"]
  }, {
    id: 18,
    word: "harmony",
    meaning: ["조화"]
  }, {
    id: 19,
    word: "cherish",
    meaning: ["소중히 여기다", "간직하다"]
  }, {
    id: 20,
    word: "ancestor",
    meaning: ["조상"]
  }, {
    id: 21,
    word: "widely",
    meaning: ["널리", "넓게", "폭넓게", "크게"]
  }, {
    id: 22,
    word: "regard",
    meaning: ["~라고 여기다", "~을 여기다"]
  }, {
    id: 23,
    word: "stage",
    meaning: ["연출하다", "무대에 올리다", "개최하다"]
  }, {
    id: 24,
    word: "promote",
    meaning: ["증진시키다", "촉진하다"]
  }, {
    id: 25,
    word: "community",
    meaning: ["공동체", "지역사회"]
  }, {
    id: 26,
    word: "try one's best",
    meaning: ["최선을 다하다", "전력을 다하다", "최선을 다해 보다"]
  }, {
    id: 27,
    word: "township",
    meaning: ["마을", "흑인 거주구"]
  }, {
    id: 28,
    word: "reflect",
    meaning: ["반영하다"]
  }, {
    id: 29,
    word: "inherit",
    meaning: ["계승하다", "계승받다", "상속받다", "물려받다"]
  }, {
    id: 30,
    word: "be divided into",
    meaning: ["~으로 나뉘다", "~로 나뉘다", "~으로 나뉘어지다", "~로 나뉘어지다"]
  }, {
    id: 31,
    word: "spirit",
    meaning: ["정신", "영혼"]
  }, {
    id: 32,
    word: "contribute",
    meaning: ["기여하다", "공헌하다"]
  }, {
    id: 33,
    word: "generation",
    meaning: ["세대"]
  }, {
    id: 34,
    word: "vary",
    meaning: ["다양하다"]
  }, {
    id: 35,
    word: "attach",
    meaning: ["덧붙이다"]
  }, {
    id: 36,
    word: "crab",
    meaning: ["게"]
  }, {
    id: 37,
    word: "cure",
    meaning: ["치료하다", "낫게 하다", "병을 고치다"]
  }, {
    id: 38,
    word: "region",
    meaning: ["지역", "구역"]
  }, {
    id: 39,
    word: "centipede",
    meaning: ["지네"]
  }, {
    id: 40,
    word: "harvest",
    meaning: ["수확", "추수"]
  }, {
    id: 41,
    word: "backache",
    meaning: ["허리통증", "요통"]
  },
]
